import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { EGI_APP_QUERIES, EgiAppQueries } from '@/app/platform/platform-data/queries/types';
import { EGI_APP_ACTIONS, EgiAppActions } from '@/app/platform/platform-data/actions/types';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

@Component({
    selector: 'egi-app-editor-view',
    templateUrl: './egi-app-editor-view.component.html',
    styleUrls: ['./egi-app-editor-view.component.css'],
    host: {
        class: 'dusk-management'
    },
    standalone: false
})
export class EgiAppEditorViewComponent implements OnInit {
  constructor(
    @Inject(EGI_APP_QUERIES)
    private readonly egiAppQueries: EgiAppQueries,
    @Inject(EGI_APP_ACTIONS)
    private readonly egiAppActions: EgiAppActions
  ) {}

  collapsed = false;
  activeAppId = '';
  editDialogOpened = false;

  ngOnInit(): void {
    this.egiAppActions.loadAll();
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  onCreated(app: EgiAppEntity) {
    this.closeDialog();
    this.onSelect(app);
  }

  onSelect(egiApp: EgiAppEntity) {
    if (this.activeAppId === egiApp.id) {
      this.activeAppId = '';
    }
    this.activeAppId = egiApp.id;
  }

  openDialog(): void {
    this.editDialogOpened = true;
  }

  closeDialog() {
    this.editDialogOpened = false;
  }

  get egiApps$(): Observable<EgiAppEntity[]> {
    return this.egiAppQueries?.all$;
  }

  get activeApp$(): Observable<EgiAppEntity> {
    return this.egiAppQueries?.one$(this.activeAppId);
  }
}
